import { Typography } from '@/components/Typography'
import { StorylineSubHeadlineModelType } from '@/types/cms/Storylines'
import styles from './StorylineSubHeadline.module.scss'

export default function StorylineSubHeadline({
  item,
}: {
  readonly item: { model: StorylineSubHeadlineModelType } | any
}) {
  return (
    <Typography as="h2" variant="xl" weight="bold" className={styles.subheadline}>
      {item.model.fields.headline?.value}
    </Typography>
  )
}
